import { useState, useEffect } from "react";
import {Container} from "react-bootstrap";
import { useAuth } from "./AuthContext";
import CompetitionsPage from "./Competitons";
import {useNavigate} from "react-router-dom";

export default function AdminPortal() {
    const { isAdmin } = useAuth();
    const navigate = useNavigate()

    useEffect(() => {

        if(!isAdmin()) {
            navigate("/leaderboard");
        }

    }, [isAdmin, navigate]);

    return (
        <Container className="mt-4">
            <CompetitionsPage />
        </Container>
    );
}